import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { breakpoint, calcRem, colors, easing, fonts } from '../../__styling'
import { StyledWrapper as VideoStyledWrapper } from '../../content/Video/Video.styled'
import { StyledCarousel } from '../Carousel/Carousel.styled'
import { StyledVideoPlayerDescriptionMoreLess } from '../VideoPlayer/VideoPlayer.styled'
import { Product, WebLink } from '@news-mono/web-common'

export const StyledWrapper = styled(VideoStyledWrapper)(({}) => ({
    display: 'flex',
    flexDirection: 'row',
    background: tokens.sevennews.colors.palette.black,
}))

export const StyledPlayerCarouselWrapper = styled('div')({
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    [breakpoint('sm')]: {
        flexDirection: 'row',
    },
    [`${StyledCarousel}`]: {
        marginLeft: 0,
        padding: calcRem(12, 16, 0, 16),
    },
})

export const StyledVideoInfoAndAdWrapper = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    [`${StyledVideoPlayerDescriptionMoreLess}`]: {
        marginBottom: calcRem(10),
        marginTop: calcRem(2),
    },
    [breakpoint('md')]: {
        flexDirection: 'row',
    },
})

export const StyledVideoPlayerInfoContainer = styled('div')(({ theme }) => ({
    marginTop: calcRem(16),
    marginBottom: calcRem(16),
    width: '100%',
    [breakpoint('md')]: {
        width: '70%',
    },
}))

export const StyledVideoPlayerInfoContainerHeader = styled('div')({
    position: 'relative',
    height: calcRem(35),
    display: 'flex',
})

export const StyledDivider = styled('span')({
    backgroundColor: 'blue',
    width: '100%',
    height: calcRem(1),
    background: colors.black20,
    opacity: 0.7,
    position: 'absolute',
    bottom: 0,
    left: 0,
    margin: 0,
    border: 'none',
    [breakpoint('md')]: {
        display: 'none',
    },
})

interface StyledShareWrapperProps {
    isOpened: boolean
}
export const StyledShareWrapper = styled('div')<StyledShareWrapperProps>(
    ({ isOpened }) => ({
        position: 'absolute',
        left: calcRem(18),
        top: 0,
        bottom: 0,
        background: tokens.sevennews.colors.palette.white,
        width: isOpened ? '100%' : 0,
        maxWidth: calcRem(230),
        borderBottom: `3px solid ${tokens.sevennews.colors.palette.red}`,
        overflow: 'hidden',
        transition: `width ${easing.easeOut.med}`,
    }),
)

export const StyledShareIconWrapper = styled('div')<StyledShareWrapperProps>(
    ({ isOpened }) => ({
        width: calcRem(18),
        height: '100%',
        cursor: 'pointer',
        marginRight: calcRem(18),
        borderBottom: `3px solid ${tokens.sevennews.colors.palette.red}`,
        '&:hover': {
            '& svg path': {
                fill: tokens.sevennews.colors.palette.red,
            },
        },
        '& svg path': {
            fill: isOpened ? tokens.sevennews.colors.palette.red : undefined,
        },
    }),
)

export const StyledVideoPlayerHeadline = styled('h2')(({ theme }) => ({
    fontSize: calcRem(22),
    fontFamily: fonts.sevennews.sansSerif,
    lineHeight: calcRem(28),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    lineClamp: 2,
    '-webkit-line-clamp': '2',
    fontWeight: 400,
    [breakpoint('sm')]: {
        fontSize: calcRem(27),
        lineHeight: calcRem(33),
        marginBottom: calcRem(8),
    },
    [breakpoint('md')]: {
        fontSize: calcRem(22),
        lineHeight: calcRem(28),
        fontWeight: 400,
    },
}))

export const StyledBylineWrap = styled('div')(({}) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center,',
    marginBottom: calcRem(16),
    [breakpoint('md')]: {
        marginBottom: calcRem(8),
    },
}))

export const StyledVideoPlayerAdContainer = styled('div')({
    width: '100%',
    [breakpoint('md')]: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '30%',
        paddingTop: calcRem(18),
    },
})

export const StyledProfileLink = styled(WebLink)({
    color: tokens.sevennews.colors.palette.black,
    textDecoration: 'none',
    fontFamily: fonts.sevennews.sansSerif,
})

export const StyledProfileLinkContainer = styled('div')(({ theme }) => ({
    display: theme.kind === Product.SevenNews ? 'inline-block' : 'none',
    marginRight: calcRem(12),
}))

export const StyledVideoPlayerDescriptionMoreLessButton = styled('button')({
    fontWeight: 500,
    cursor: 'pointer',
    padding: 0,
    margin: 0,
    background: 'none',
    border: 'none',
    color: colors.sevennews.bauhausBlack,
    [breakpoint('sm')]: {
        fontSize: calcRem(18),
    },
    [breakpoint('md')]: {
        fontSize: calcRem(20),
        lineHeight: calcRem(25),
    },
})
